<div>
	<div class="kit__utils__heading">
		<h5>
			<span class="mr-3">Hardwarespielwiese</span>
		</h5>
	</div>

	<div class="card">
		<div class="card-body">
			<h5 class="mb-4">
				<strong>Hardwarespielwiese</strong>
			</h5>
			<div nz-row class="mb-3">
				<div nz-col nzSpan="6">
					<div class="bg-light" style="padding: 10px">
						<button nz-button nzType="primary" class="mr-3 mb-3" (click)="randomize()">Randomize</button>
					</div>
				</div>
				<div nz-col nzSpan="6">
					<div class="bg-light" style="padding: 10px">
						<button nz-button nzType="default" class="mr-3 mb-3">Button 2</button>
					</div>
				</div>
				<div nz-col nzSpan="6">
					<div class="bg-light" style="padding: 10px">
						<button nz-button nzType="dashed" class="mr-3 mb-3" (click)="hilfMir()">{{button3title}}</button>
					</div>
				</div>
				<div nz-col nzSpan="6">
					<div class="bg-light" style="padding: 10px">
						<button nz-button nzType="danger" class="mr-3 mb-3" (click)="omg()">Button OMG!</button>
					</div>
				</div>
			</div>

			<nz-table #dynamicTable [nzScroll]="fixHeader ? { y: '240px' } : null" [nzData]="listOfData" [nzBordered]="bordered"
								[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
								[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzFooter]="footer ? 'Here is the Footer' : null"
								[nzTitle]="title ? 'Here is the Title' : null" [nzSize]="size" (nzCurrentPageDataChange)="currentPageDataChange($event)"
								class="kit__utils__table">
				<thead>
				<tr *ngIf="header">
					<th nzWidth="50px" nzShowExpand *ngIf="expandable"></th>
					<th nzWidth="62px" nzShowCheckbox *ngIf="checkbox" [(nzChecked)]="allChecked" [nzIndeterminate]="indeterminate"
							(nzCheckedChange)="checkAll($event)"></th>
					<th nzWidth="150px">Name</th>
					<th nzWidth="70px">Age</th>
					<th>Address</th>
					<th nzWidth="260px">Action</th>
				</tr>
				</thead>
				<tbody>
				<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
					<tr>
						<td nzShowExpand *ngIf="expandable" [(nzExpand)]="data.expand"></td>
						<td nzShowCheckbox *ngIf="checkbox" [(nzChecked)]="data.checked" (nzCheckedChange)="refreshStatus()"></td>
						<td>{{ data.name }}</td>
						<td>{{ data.age }}</td>
						<td>{{ data.address }}</td>
						<td>
							<a href="#">Action 一 {{ data.name }}</a>
							<nz-divider nzType="vertical"></nz-divider>
							<a href="#">Delete</a>
						</td>
					</tr>
					<tr [nzExpand]="data.expand && expandable">
						<td></td>
						<td [attr.colspan]="checkbox ? 5 : 4">{{ data.description }}</td>
					</tr>
				</ng-template>
				</tbody>
			</nz-table>
		</div>
	</div>

	<div class="card">
		<div class="card-body">

			<div nz-row>
				<div nz-col nzSpan="12">
					<h5 class="mb-4">
						<strong>Random</strong>
					</h5>
					<div class="mb-5">
						<div id="random"></div>
					</div>
				</div>
				<div nz-col nzSpan="12">
					<h5 class="mb-4">
						<strong>Bar</strong>
					</h5>
					<div class="mb-5">
						<div id="bar"></div>
					</div>
				</div>
			</div>

			<div nz-row>
				<div nz-col [nzSpan]="24" [nzLg]="12">
					<h5 class="mb-4">
						<strong>Sub Chart</strong>
					</h5>
					<div class="mb-5">
						<div id="sub-chart"></div>
					</div>
				</div>
				<div nz-col [nzSpan]="24" [nzLg]="12">
					<h5 class="mb-4">
						<strong>Scatter</strong>
					</h5>
					<div class="mb-5">
						<div id="scatter"></div>
					</div>
				</div>
			</div>

		</div>
	</div>

</div>
